module.exports = "pegasus/assets/themelp1/charity/105.png";